import { z } from 'zod';

export const FrontendEnvSchema = z.object({
  VITE_API_URL: z
    .string()
    .refine(
      (value) => value.startsWith('/') || z.url().safeParse(value).success,
      'VITE_API_URL must be a relative path or a valid URL',
    )
    .default('/api/trpc'),
});

export type FrontendEnv = z.infer<typeof FrontendEnvSchema>;

export function getFrontendEnv(
  envSource: Record<string, string | undefined> = import.meta.env,
): FrontendEnv {
  return FrontendEnvSchema.parse(envSource);
}
